<template lang="html">
  <div class="main">
    <SoundslidesPlayer v-if="$route.meta.exact" :path="path" :use-show-dimensions="true" :solo-player="true" class="center" />
    <SoundslidesPlayer v-if="$route.meta.fill" :path="path" :fillscreen="true" :solo-player="true" />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "LegacyHostingPlayer",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {
    }
  },
  computed:{
    path(){
      var id = this.$route.params.id;
      if(id.length === 5){
        // Legacy hosting.
        return `https://s3.amazonaws.com/hosting.soundslides.com/${id}/`
      }else{
        return `https://s3.amazonaws.com/new.soundslides.hosting/${id}/`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main{
  position: absolute;
  width: 100%;
  height: 100%;
}
.center{
  position: relative;
  top: 33%;
  left: 50%;
  transform: translateX(-50%) translateY(-33%);
  max-width: 100%;
  max-height: 100%;
}
</style>
